import { fork, takeEvery, cancel, select, call } from 'redux-saga/effects'
import { matchPath } from 'react-router-dom'
import { query as querySelector } from 'domain/router'
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router'
import { Task } from 'redux-saga'
import { constantsSelector, State } from 'domain/constants'
import { ensureGetConstants } from 'domain/constants/sagas'
import * as MProfile from 'pages/Manager/Profile/sagas'
import * as MJobsEdit from 'pages/Manager/Jobs/Edit/sagas'
import * as MJobsView from 'pages/Manager/Jobs/View/sagas'
import * as MJobsList from 'pages/Manager/Jobs/List/sagas'
import * as MJobDraftsView from 'pages/Manager/JobDrafts/View/sagas'
import * as MJobDraftsList from 'pages/Manager/JobDrafts/List/sagas'
import * as MCampaignsList from 'pages/Manager/Campaigns/List/sagas'
import * as MCampaignView from 'pages/Manager/Campaigns/View/sagas'
import * as MCampaignEdit from 'pages/Manager/Campaigns/Edit/sagas'
import * as MRecruiters from 'pages/Manager/Recruiters/List/sagas'
import * as MRecruiterView from 'pages/Manager/ProfileView/Recruiter/sagas'
import * as MManagerView from 'pages/Manager/ProfileView/Manager/sagas'
import * as MCandidates from 'pages/Manager/Candidates/List/sagas'
import * as MCandidateView from 'pages/Manager/Candidates/View/sagas'
import * as MClients from 'pages/Manager/Clients/List/sagas'
import * as MDashboard from 'pages/Manager/Dashboard/sagas'
import * as MCalendar from 'pages/Manager/Calendar/sagas'
import * as MRecruiterClients from 'pages/Manager/Recruiters/ClientsList/sagas'
import * as MRecruitersJobs from 'pages/Manager/Recruiters/Jobs/sagas'
import * as MClientsJobs from 'pages/Manager/Clients/Jobs/sagas'
import * as MSkills from 'pages/Manager/Skills/List/sagas'
import * as MSkillsEdit from 'pages/Manager/Skills/Edit/sagas'
import * as CProfile from 'pages/Candidate/Profile/sagas'
import * as CJobsList from 'pages/Candidate/Jobs/List/sagas'
import * as CJobsView from 'pages/Candidate/Jobs/View/sagas'
import * as CManagerView from 'pages/Candidate/ProfileView/Manager/sagas'
import * as CRecruiterView from 'pages/Candidate/ProfileView/Recruiter/sagas'
import * as CCandidateView from 'pages/Candidate/ProfileView/Candidate/sagas'
import * as CCalendar from 'pages/Candidate/Calendar/sagas'
import * as CDashboard from 'pages/Candidate/Dashboard/sagas'
import * as RDashboard from 'pages/Recruiter/Dashboard/sagas'
import * as RProfile from 'pages/Recruiter/Profile/sagas'
import * as RJobsView from 'pages/Recruiter/Jobs/View/sagas'
import * as RJobsList from 'pages/Recruiter/Jobs/List/sagas'
import * as RManagerView from 'pages/Recruiter/ProfileView/Manager/sagas'
import * as RRecruiterView from 'pages/Recruiter/ProfileView/Recruiter/sagas'
import * as RCandidates from 'pages/Recruiter/Candidates/List/sagas'
import * as RResumes from 'pages/Recruiter/Resumes/List/sagas'
import * as RCandidateProfile from 'pages/Recruiter/Candidates/View/sagas'
import * as RCandidateProfileEdit from 'pages/Recruiter/Candidates/Edit/sagas'
import * as RCandidateProfileAdd from 'pages/Recruiter/Candidates/Add/sagas'
import * as RCandidateProfileAddFromResume from 'pages/Recruiter/Candidates/AddFromResume/sagas'
import * as Messages from 'pages/Messages/sagas'
import * as Auth from 'pages/Auth/sagas'
import * as GuestJobs from 'pages/Guest/Jobs/sagas'
import * as Notifications from 'pages/Notifications/sagas'
import * as SuperManagerProfile from 'pages/SuperManager/Profile/sagas'
import * as SuperManagerJobsView from 'pages/SuperManager/Jobs/View/sagas'
import * as SuperManagerJobs from 'pages/SuperManager/Jobs/List/sagas'
import * as SMManager from 'pages/SuperManager/ProfileView/Manager/sagas'
import * as SuperManagerClients from 'pages/SuperManager/Clients/List/sagas'
import * as SuperManagerDashboard from 'pages/SuperManager/Dashboard/sagas'
import * as SMCandidateProfile from 'pages/SuperManager/Candidates/View/sagas'
import * as SMCandidatesJobs from 'pages/SuperManager/Jobs/ClientsJobs/sagas'
import { userSelector } from '../domain/env'
import { checkAuth } from '../domain/env/sagas'

interface PathItemType {
  path: string
  fn: (...args: any[]) => any
  exact: boolean
}

const path: Record<string, PathItemType[]> = {
  common: [
    { path: '/account/confirmation', fn: Auth.confirmationToken, exact: true },
    { path: '/log-in-otp', fn: Auth.signInPage, exact: true },
    { path: '/log-in', fn: Auth.signInPage, exact: true },
    { path: '/sign-up', fn: Auth.signUpPage, exact: true },
    { path: '/account/password-reset', fn: Auth.updatePassword, exact: true },
    { path: '/reset-password', fn: Auth.recoveryPasswordPage, exact: true },
    { path: '/recruiter-invite', fn: Auth.recruiterAccept, exact: true },
    { path: '/guest/job/:id', fn: Auth.recommendJobAccept, exact: true },
    { path: '/notifications', fn: Notifications.notificationsPage, exact: true },
    { path: '/candidate-invite', fn: Auth.candidateInvite, exact: true },
    { path: '/', fn: Auth.signOut, exact: true }
  ],

  // Hiring Manager
  manager: [
    { path: '/manager/job-drafts/:id', fn: MJobDraftsView.jobDraftView, exact: true },
    { path: '/manager/job-drafts', fn: MJobDraftsList.jobDraftsList, exact: true },
    { path: '/jobs/view/:id', fn: MJobsView.jobsView, exact: true },
    {
      path: '/jobs/:jobId/candidates/:candidateId',
      fn: MCandidateView.profilePage,
      exact: true
    },
    { path: '/jobs/:id/candidates', fn: MCandidates.candidatesPage, exact: true },
    { path: '/jobs/:id', fn: MJobsEdit.jobsEdit, exact: true },
    { path: '/jobs/clone/:id', fn: MJobsEdit.jobsClone, exact: true },
    { path: '/jobs', fn: MJobsList.jobsList, exact: true },
    { path: '/profile', fn: MProfile.profilePage, exact: true },
    { path: '/dashboard', fn: MDashboard.dashboard, exact: true },
    {
      path: '/manager/candidates/:candidateId',
      fn: MCandidateView.profilePage,
      exact: true
    },
    { path: '/manager/recruiters-jobs', fn: MRecruitersJobs.jobsList, exact: true },
    { path: '/clients-jobs', fn: MClientsJobs.jobsList, exact: true },
    { path: '/clients', fn: MClients.clients, exact: true },
    { path: '/manager/recruiters/:id', fn: MRecruiterView.profilePage, exact: true },
    { path: '/manager/recruiters', fn: MRecruiters.recruitersList, exact: true },
    { path: '/manager/managers/:id', fn: MManagerView.profilePage, exact: true },
    { path: '/calendar', fn: MCalendar.calendar, exact: true },
    { path: '/recruiters-clients', fn: MRecruiterClients.clients, exact: true },
    { path: '/campaigns', fn: MCampaignsList.campaignsList, exact: true },
    { path: '/campaigns/view/:id', fn: MCampaignView.campaignView, exact: true },
    { path: '/campaigns/edit/:id', fn: MCampaignEdit.campaignEdit, exact: true },
    { path: '/skills/:id', fn: MSkillsEdit.skillEdit, exact: true },
    { path: '/skills', fn: MSkills.skillsPage, exact: true },

    /* @deprecated */
    { path: '/manager/jobs/view/:id', fn: MJobsView.jobsView, exact: true },
    {
      path: '/manager/jobs/:jobId/candidates/:candidateId',
      fn: MCandidateView.profilePage,
      exact: true
    },
    { path: '/manager/jobs/:id/candidates', fn: MCandidates.candidatesPage, exact: true },
    { path: '/manager/jobs/:id', fn: MJobsEdit.jobsEdit, exact: true },
    { path: '/manager/jobs/clone/:id', fn: MJobsEdit.jobsClone, exact: true },
    { path: '/manager/jobs', fn: MJobsList.jobsList, exact: true }
  ],

  // Recruiter
  recruiter: [
    {
      path: '/jobs/:jobId/candidates/:candidateId',
      fn: RCandidateProfile.profilePage,
      exact: true
    },
    { path: '/jobs/view/:id', fn: RJobsView.jobsView, exact: true },
    { path: '/jobs', fn: RJobsList.jobsList, exact: true },
    { path: '/profile', fn: RProfile.profilePage, exact: true },
    { path: '/recruiter/managers/:id', fn: RManagerView.profilePage, exact: true },
    { path: '/recruiter/recruiters/:id', fn: RRecruiterView.profilePage, exact: true },
    { path: '/dashboard', fn: RDashboard.dashboard, exact: true },
    { path: '/recruiter/candidates/add', fn: RCandidateProfileAdd.profilePage, exact: true },
    {
      path: '/recruiter/candidates/add-from-resume/:id',
      fn: RCandidateProfileAddFromResume.profilePage,
      exact: true
    },
    { path: '/recruiter/candidates/:id/edit', fn: RCandidateProfileEdit.profilePage, exact: true },
    { path: '/recruiter/candidates/:id', fn: RCandidateProfile.profilePage, exact: true },
    { path: '/recruiter/candidates', fn: RCandidates.candidatesPage, exact: true },
    { path: '/resumes', fn: RResumes.resumesPage, exact: true },
    { path: '/messages', fn: Messages.messagesPage, exact: true },

    /* @deprecated */
    {
      path: '/recruiter/jobs/:jobId/candidates/:candidateId',
      fn: RCandidateProfile.profilePage,
      exact: true
    },
    { path: '/recruiter/jobs/view/:id', fn: RJobsView.jobsView, exact: true },
    { path: '/recruiter/jobs', fn: RJobsList.jobsList, exact: true }
  ],

  // Candidate
  candidate: [
    { path: '/jobs/view/:id', fn: CJobsView.jobsView, exact: true },
    { path: '/jobs', fn: CJobsList.jobsList, exact: true },
    { path: '/profile', fn: CProfile.profilePage, exact: true },
    { path: '/candidate/managers/:id', fn: CManagerView.profilePage, exact: true },
    { path: '/candidate/recruiters/:id', fn: CRecruiterView.profilePage, exact: true },
    { path: '/candidate/candidates/:id', fn: CCandidateView.profilePage, exact: true },
    { path: '/calendar', fn: CCalendar.calendar, exact: true },
    { path: '/messages', fn: Messages.messagesPage, exact: true },
    { path: '/dashboard', fn: CDashboard.dashboard, exact: true },

    /* @deprecated */
    { path: '/candidate/jobs/view/:id', fn: CJobsView.jobsView, exact: true },
    { path: '/candidate/jobs', fn: CJobsList.jobsList, exact: true }
  ],

  // guest
  guest: [
    { path: '/guest/jobs/:campaign', fn: GuestJobs.jobsListGuest, exact: true },
    { path: '/find-jobs/view/:id', fn: GuestJobs.jobsListGuest, exact: true },
    { path: '/find-jobs/:campaign', fn: GuestJobs.jobsListGuest, exact: true },
    { path: '/guest/jobs', fn: GuestJobs.jobsListGuest, exact: true },
    { path: '/find-jobs', fn: GuestJobs.jobsListGuest, exact: false }
  ],

  // Super Manager
  super_manager: [
    {
      path: '/jobs/:jobId/candidates/:candidateId',
      fn: SMCandidateProfile.profilePage,
      exact: true
    },
    { path: '/jobs/view/:id', fn: SuperManagerJobsView.jobView, exact: true },
    { path: '/jobs', fn: SuperManagerJobs.jobsList, exact: true },
    { path: '/profile', fn: SuperManagerProfile.profilePage, exact: true },
    { path: '/clients-jobs', fn: SMCandidatesJobs.jobsList, exact: true },
    { path: '/super_manager/managers/:id', fn: SMManager.profilePage, exact: true },
    { path: '/clients', fn: SuperManagerClients.clientsList, exact: true },
    { path: '/dashboard', fn: SuperManagerDashboard.dashboard, exact: true },

    /* @deprecated */
    {
      path: '/super_manager/jobs/:jobId/candidates/:candidateId',
      fn: SMCandidateProfile.profilePage,
      exact: true
    },
    { path: '/super_manager/jobs/view/:id', fn: SuperManagerJobsView.jobView, exact: true },
    { path: '/super_manager/jobs', fn: SuperManagerJobs.jobsList, exact: true }
  ]
}

let task: Task

function* routeMatcher({ payload: { location } }: LocationChangeAction) {
  const constants = yield select(constantsSelector)
  if (!constants || constants.isEmpty() || constants === State) yield call(ensureGetConstants)
  const user = yield select(userSelector)
  let role = user.get('role')
  if (!role) {
    yield call(checkAuth)
    const updatedUser = yield select(userSelector)
    role = updatedUser.get('role') || 'guest'
  }
  const rolePaths = Array.isArray(path[role]) ? path[role] : []
  const pathList = [...rolePaths, ...path.common]

  for (const item of pathList) {
    const match = matchPath(location.pathname, {
      exact: 'exact' in item ? item.exact : true,
      strict: false,
      ...item
    })
    if (task) yield cancel(task)
    const query = yield select(querySelector)
    if (match !== null) {
      task = yield fork(item.fn, { ...location, query }, match)
      break
    }
  }
}

export default function* navigator() {
  yield takeEvery(LOCATION_CHANGE, routeMatcher)
}
